import * as React from 'react';
import { useSelector } from 'react-redux';

import { PrintContainer } from './print';
import { RemoveContainer } from './remove/RemoveContainer';
import { selectSelectedFolder } from '../../selectors/folders';
import { selectSelectedEntitiesCount } from '../../selectors/selected';

export const MassActionsContainer = () => {
  const isSelected = Boolean(useSelector(selectSelectedEntitiesCount));
  const selectedFolder = Boolean(useSelector(selectSelectedFolder));

  return (
    <>
      {isSelected && <PrintContainer />}
      {(!selectedFolder || isSelected) && <RemoveContainer />}
    </>
  );
};
